import React from 'react';
import Enzimi from '../../assets/images/Enzimi_bordo_4.png'
import { useTranslation } from 'react-i18next';
import './Enzymes.css'

function Enzymes() {
  const { t } = useTranslation();

  const products = [
   
    {
        name: t('ICEzym BIANCHI'),
        description: t('Pectolytic enzyme purified by cinnamilesterase activities (FCE) stabilized at low pH ideal for the clarification of musts. It is characterized by a balanced pectolytic activity profile (polygalacturonase, pectinmethylesterase and pectinlyase), which allows rapid sedimentation of the pectic substances present in the must.'),
      },
      {
        name: t('ICEzym BIANCHI MP'),
        description: t('Enzyme preparation with high pectolytic activity with secondary activities degrading the cell wall. It was developed for a specific action during the maceration of white grapes to obtain high-end wines.'),
      },
      {
        name: t('ICEzym LYSE'),
        description: t('Enzyme preparation developed to enhance the sensation of volume and roundness in the mouth. Betaglucanase allows, by working on fine lees, to obtain products rich in polysaccharides.'),
      },
      {
        name: t('ICEzym ROSSI'),
        description: t('Pectolytic enzymatic preparation specific for the maceration of red grapes, free from anthocyanase, specifically designed to increase the quality of red wine. The specific activities, main and secondary, stabilized at a low pH, are able to operate in synergy to favor the extraction of the coloring substances and noble tannins contained in the peel cells.'),
      },
      {
        name: t('ICEzym FLOT'),
        description: t('Enzyme pool in granular form with high pectolytic activity, designed to facilitate the clarification of musts during flotation. The use of ICEzym Flot allows the viscosity of the medium to be reduced, speeding up the rise of the particles to the surface, implementing the working capacity of the flotation system.'),
      },
     
     
  ];

  return (
    <>
  <div className="mainEnzymesImg">
  <div className="EnzymesImg1"></div>

  <div className="EnzymesImg2">
    <h1 className="EnzymesTitle">{t("Enzymes")}</h1>
    <img src={Enzimi} alt="Enzymes" className="EnzymesImage" />
  </div>
</div>
    
    <div className="main-infocontainer">
      {products.map((product, index) => (
        <div className="item-container" key={index}>
          {/* <img src={product.image} alt={product.name} /> */}
          <div className="text-info">
            <h1>{product.name}</h1>
            <p>{product.description}</p>
          </div>
        </div>
      ))}
    </div>
    </>
  );
}

export default Enzymes;
